<template>
    <div class="d-inline" v-if="text">
        <span class="text-muted small">смсок: {{sms}} ({{symbols}} симв.)</span> <HelpPopover about="Количество символов в смс" />
    </div>
</template>

<script>
import HelpPopover from "../others/HelpPopover.vue";

export default {
    name: "CalculatorSms",
    components: {HelpPopover},
    props: ['text'],
    computed: {
        symbols() {
            return this.text.length;
        },
        sms() {
            let l = this.text.length;
            if(/[а-яА-ЯёЁ]/.test(this.text)) {
                if (l <= 70) return 1;
                return Math.ceil(l / 67);
            } else {
                if (l <= 160) return 1;
                return Math.ceil(l / 153);
            }
        }
    }
}
</script>

<style scoped>

</style>